import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { lifecycle, withProps, compose, branch, renderNothing, withHandlers } from 'recompose'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as InboxActions from 'app/modules/inbox/actions'
import * as InboxSelectors from 'app/modules/inbox/selectors'
import * as UserSelectors from 'app/modules/user/selectors'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as OrgSelectors from 'app/modules/org/selectors'
import * as OrgActions from 'app/modules/org/actions'
import * as EmbedSelectors from 'app/modules/embed/selectors'
import * as EmbedActions from 'app/modules/embed/actions'
import { MarketingEmailLayouts } from 'app/modules/playbook/constants'
import ACCESS from 'utils/Access'

import { EmailEditCard } from './component'

const mapStateToProps = (state, props) => ({
  orgUsers: UserSelectors.currentOrgUsersAlphabetical(state),
  marketingEmailLayout: PlaybookSelectors.marketingEmailLayout(state),
  currentUser: UserSelectors.currentUser(state),
  inboxes: InboxSelectors.inboxes(state),
  isInboxListLoading: InboxSelectors.isInboxListLoading(state),
  isInboxListLoaded: InboxSelectors.isInboxListLoaded(state),
  orgName: OrgSelectors.orgName(state),
  orgLogoUrl: OrgSelectors.orgLogoUrl(state),
  orgTwitterUrl: EmbedSelectors.orgTwitterLink(state),
  orgLinkedinUrl: EmbedSelectors.orgLinkedinLink(state),
  orgFacebookUrl: EmbedSelectors.orgFacebookLink(state),
  orgAddress: EmbedSelectors.orgAddress(state),
  embedFetchPending: EmbedSelectors.embedFetchPending(state),
  playbookId: PlaybookSelectors.draftId(state),
  isOrgLoaded: OrgSelectors.isLoaded(state),
  isBannerUploadPending: PlaybookSelectors.isBannerUploadPending(state, props.id),
  hasDynamicSenderEnabled: ACCESS.isAtLeastProPlan(),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchInboxList: InboxActions.fetchInboxList,
      sendTestEmail: PlaybookActions.sendTestEmail,
      showEditSenderModal: PlaybookActions.showEditSenderModal,
      fetchEmbed: EmbedActions.fetchEmbed,
      fetchOrg: OrgActions.fetchOrg,
      setEmailBanner: PlaybookActions.setEmailBanner,
      clearEmailBanner: PlaybookActions.clearEmailBanner,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const { actions, isInboxListLoaded, isInboxListLoading, includeSenderSelect } = this.props
      if (!isInboxListLoaded && !isInboxListLoading && includeSenderSelect) {
        actions.fetchInboxList()
      }
    },
  }),
  branch(({ orgUsers, isInboxListLoaded, includeSenderSelect }) => !orgUsers.size || (!isInboxListLoaded && includeSenderSelect), renderNothing),
  withProps(props => ({
    authorId: props.authorId || _.get(props, 'emailMessage.authorId'),
    senderName: props.sendFromOverride || _.get(props, 'emailMessage.sendFromOverride') || '',
    emailOverride: props.senderEmailOverride || _.get(props, 'emailMessage.senderEmailOverride') || '',
    dynamicAccountSendAttribute: props.dynamicAccountSendAttribute || _.get(props, 'emailMessage.dynamicAccountSendAttribute'),
    showCompanyLogo: props.marketingEmailLayout === MarketingEmailLayouts.WITH_COMPANY_LOGO,
    showHeroImage: props.marketingEmailLayout === MarketingEmailLayouts.WITH_HERO_IMAGE,
    showCompanyFooter: [MarketingEmailLayouts.WITH_COMPANY_LOGO, MarketingEmailLayouts.WITH_HERO_IMAGE].includes(props.marketingEmailLayout),
    defaultUser:
      props.orgUsers.toJS().find(user => [props.emailMessage.authorId, props.authorId].includes(user.id) || user.email === props.authorId) || props.orgUsers.first().toJS(),
  })),
  lifecycle({
    componentDidMount() {
      if (!this.props.emailOverride) {
        this.props.setAuthorId(this.props.defaultUser.id)
        this.props.setEmailOverride(this.props.defaultUser.email)
        this.props.setSenderName(this.props.defaultUser.name)
      }
    },
  }),
  withProps(props => {
    const inboxEmailIsOverride = props.inboxes.find(inbox => inbox.get('address') === props.emailOverride)
    return {
      placeholderName: getDisplayName(props.defaultUser),
      message: props.emailMessage.message,
      headline: props.emailMessage.title,
      selectedUserId: inboxEmailIsOverride ? props.emailOverride : props.authorId,
    }
  }),
  withHandlers({
    onSenderNameChange: props => e => {
      props.setSenderName(e.target.value)
    },
    onMessageChange: props => content => {
      props.setMessage(content)
    },
    onHeadlineChange: props => event => {
      props.setHeadline(event.target.value)
    },
    onEditSenderClick: props => () => {
      props.actions.showEditSenderModal(props.id)
    },
    onUserIdChange: props => ({ isInbox, value }) => {
      if (isInbox) {
        props.setAuthorId(props.currentUser.get('id', 0))
        props.setEmailOverride(value)
      } else {
        props.setAuthorId(value)
        const sendFromAuthor = props.orgUsers.find(user => user.id === value)
        sendFromAuthor && props.setEmailOverride(sendFromAuthor.email)
      }
    },
    onSendTestEmailClick: props => () => {
      props.actions.sendTestEmail({ emailId: props.id })
    },
    onBannerUpload: props => files => {
      const { actions: { setEmailBanner }} = props
      setEmailBanner({ file: files[0], emailId: props.id })
    },
    onBannerClear: props => () => {
      const { actions: { clearEmailBanner }} = props
      clearEmailBanner({ emailId: props.id })
    },
    renderSelectedUser: props => option => {
      const selectedValueIsInbox = !!props.inboxes.find(inbox => inbox.get('address') === props.emailOverride)
      const selectedUser = props.orgUsers.find(user => user.id === props.authorId)
      const selectedEmail = selectedUser ? selectedUser.email : option.value.value
      return (
        <div className="Select-value">
          <span className="Select-value-label">{selectedValueIsInbox ? props.emailOverride : selectedEmail }</span>
        </div>
      )
    },
  }),
)(EmailEditCard)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailEditCard/index.js